import { useState } from "react";

export const useForm = <F extends {}>(formValues: F) => {
  const [values, setValues] = useState(formValues);

  const onChange = <K extends keyof F>(key: K, value: F[K]) => {
    setValues((previous) => ({
      ...previous,
      [key]: value,
    }));
  };

  const onBatchChange = (newValues: Partial<F>) => {
    setValues((previous) => ({
      ...previous,
      ...newValues,
    }));
  };

  return [values, onChange, onBatchChange] as const;
};
